import { render, staticRenderFns } from "./aboutUS.vue?vue&type=template&id=097a527d&scoped=true"
import script from "./aboutUS.vue?vue&type=script&lang=js"
export * from "./aboutUS.vue?vue&type=script&lang=js"
import style0 from "./aboutUS.vue?vue&type=style&index=0&id=097a527d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097a527d",
  null
  
)

export default component.exports